module.exports = __webpack_public_path__ + "static/media/page02.d5951876.jpg";